import { render, staticRenderFns } from "./AgentOverDue.vue?vue&type=template&id=71469692"
import script from "./AgentOverDue.vue?vue&type=script&lang=js"
export * from "./AgentOverDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports